import orderBy from 'lodash/fp/orderBy';
import groupBy from 'lodash/fp/groupBy';
import { Dictionary } from 'lodash';
import { DocumentDto } from '../../interfaces/Dto/DocumentDto';
import { DocumentGroup } from '../../interfaces/DocumentGroup';
import transformDocuments from './transformDocuments';
import { DocumentGroupingDto } from '../../interfaces/Dto/DocumentGroupingDto';

export default function groupDocuments(dtos: DocumentDto[], documentGroupings: DocumentGroupingDto[]): DocumentGroup[] {
  const groups: Dictionary<DocumentDto[]> = groupBy((dto: DocumentDto) => dto.year)(dtos);
  const items: DocumentGroup[] = Object.keys(groups).map((key: string) => ({
    period: key,
    documents: transformDocuments(groups[key], documentGroupings),
  }));
  return orderBy((d: DocumentGroup) => d.period, 'desc')(items);
}
